// Error logging that is safe in production. Axios errors carry the request config (including the
// Bearer token and the request body) and the response body, so they must never be logged whole.

export interface ErrorSummary {
  status?: number;
  errorCode?: string;
  failure?: string;
  name?: string;
}

/** Only the HTTP status and backend error code: no config, headers, bodies or messages. */
export function describeError(error: unknown): ErrorSummary {
  const e = error as any;
  if (e && e.isAxiosError) {
    const errorCode = e.response?.data?.errorCode;
    return {
      status: e.response?.status,
      errorCode: typeof errorCode === "string" ? errorCode : undefined,
    };
  }
  if (e && e.isWebEncryptionError) {
    return { failure: e.failure };
  }
  // Messages can quote data (e.g. JSON.parse), so only the error type is kept.
  return { name: e instanceof Error ? e.name : typeof e };
}

export function logError(context: string, error?: unknown) {
  if (error === undefined) {
    console.error(context);
  } else {
    console.error(context, describeError(error));
  }
}
